import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

export const DIALOG_TYPE = 'sending';

@Component({
  selector: 'app-sending-dialog',
  templateUrl: './sending-dialog.component.html',
  styleUrls: ['./sending-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SendingDialogComponent implements OnInit {
  dialogType: string;

  constructor() {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
  }
}
